import { useEffect, useState, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * useMaintenanceMode
 *
 * Polls /api/system/status. Returns `{ enabled, loading, refresh }`.
 * A single 30s interval keeps the flag fresh so an admin toggle propagates
 * to every open browser tab without a manual refresh.
 */
export function useMaintenanceMode() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/system/status`, { cache: 'no-store' });
      if (res.ok) {
        const data = await res.json();
        setEnabled(!!data.maintenance_mode);
      }
    } catch (_err) {
      // Fail-open: if the status endpoint is unreachable, do not lock the whole app.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 30000);
    return () => clearInterval(id);
  }, [refresh]);

  return { enabled, loading, refresh };
}
